import SvgIcoStackFiles from './SvgIcoStackFiles';

export default SvgIcoStackFiles;
